// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vdatetime-input:disabled.vs-input--input {\n  opacity: 1;\n}\n[dir] .vdatetime-input:disabled {\n  background-color: #00000000;\n}\n.properSlider {\n  width: 200px !important;\n}\n.tooltipZFix {\n  z-index: 60000 !important;\n}\n.overlay-container{\n  max-height: 100px !important;\n  position: relative !important;\n}\n.overlayed{\n  position: absolute !important;\n}\n\n/* ._profile-details .con-select {\n  width: auto !important;\n\n} */\n\n", ""]);
// Exports
module.exports = exports;
